var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"id":"spinner-img","src":require("../../assets/img/owal-logo-transparent.png"),"alt":"Spinning Owal Logo"}}),_c('div',{attrs:{"id":"caption"}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }